/* tslint:disable */
/* eslint-disable */
/**
 * data-center
 * data-center
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OmniGenerateDashboardIFrameUrlRequest
 */
export interface OmniGenerateDashboardIFrameUrlRequest {
    /**
     * 
     */
    facility_type: OmniGenerateDashboardIFrameUrlRequestFacilityTypeEnum;
    /**
     * 
     */
    dashboard_id: string;
    /**
     * 
     */
    open_ask_ai?: boolean;
    /**
     * 
     */
    user_timezone?: string;
}


/**
 * @export
 */
export const OmniGenerateDashboardIFrameUrlRequestFacilityTypeEnum = {
    SkilledNursing: 'SKILLED_NURSING',
    CriticalCare: 'CRITICAL_CARE',
    HomeHealth: 'HOME_HEALTH',
    AssistedLiving: 'ASSISTED_LIVING',
    LongTermCareHospital: 'LONG_TERM_CARE_HOSPITAL',
    Hospice: 'HOSPICE',
    DialysisCenter: 'DIALYSIS_CENTER',
    Hospital: 'HOSPITAL',
} as const;
export type OmniGenerateDashboardIFrameUrlRequestFacilityTypeEnum = typeof OmniGenerateDashboardIFrameUrlRequestFacilityTypeEnum[keyof typeof OmniGenerateDashboardIFrameUrlRequestFacilityTypeEnum];


/**
 * Check if a given object implements the OmniGenerateDashboardIFrameUrlRequest interface.
 */
export function instanceOfOmniGenerateDashboardIFrameUrlRequest(value: object): value is OmniGenerateDashboardIFrameUrlRequest {
    if (!('facility_type' in value) || value['facility_type'] === undefined) return false;
    if (!('dashboard_id' in value) || value['dashboard_id'] === undefined) return false;
    return true;
}

export function OmniGenerateDashboardIFrameUrlRequestFromJSON(json: any): OmniGenerateDashboardIFrameUrlRequest {
    return OmniGenerateDashboardIFrameUrlRequestFromJSONTyped(json, false);
}

export function OmniGenerateDashboardIFrameUrlRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OmniGenerateDashboardIFrameUrlRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_type': json['facility_type'],
        'dashboard_id': json['dashboard_id'],
        'open_ask_ai': json['open_ask_ai'] == null ? undefined : json['open_ask_ai'],
        'user_timezone': json['user_timezone'] == null ? undefined : json['user_timezone'],
    };
}

export function OmniGenerateDashboardIFrameUrlRequestToJSON(json: any): OmniGenerateDashboardIFrameUrlRequest {
    return OmniGenerateDashboardIFrameUrlRequestToJSONTyped(json, false);
}

export function OmniGenerateDashboardIFrameUrlRequestToJSONTyped(value?: OmniGenerateDashboardIFrameUrlRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_type': value['facility_type'],
        'dashboard_id': value['dashboard_id'],
        'open_ask_ai': value['open_ask_ai'],
        'user_timezone': value['user_timezone'],
    };
}

